import { createSlice } from "@reduxjs/toolkit";
import { State } from "./store";

const initialState = {
  users: [{
    id: "",
    tenantId: "",
    // updateAt: new Date('1970-01-01'),
    admin: false,
    deleteFlg: false
  }],
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    usersSet: (state, action) => {
      state.users = action.payload
    }
  }
});

export const {usersSet} = usersSlice.actions;
export const selectorUsers = (state: State) => state.user.users;

export const usersReducer = usersSlice.reducer;